import { ShoppingListPage } from './pages/ShoppingListPage';

export const shoppingListRoutes = {
  path: 'shopping-list',
  children: [{
    path: '',
    element: <ShoppingListPage />,
  }],
};

